import queryParams from '@/utils/query-params';
import inputEventBus from '@/mixins/input-eventbus';
import closest from '@/mixins/closest';

export default {
    render(h) {
        const template = h('div', [
            this.$scopedSlots.default({
                isInitialized: this.isInitialized,
                currentQuery: this.currentQuery,
                sortBy: this.sortBy,
                numResults: this.numResults,
                formData: this.formData,
                flaggedData: this.flaggedData,
                id: this.id,
                isValid: this.isValid,
                submitSearch: this.submitSearch,
                manualSubmitSearch: this.manualSubmitSearch,
                checkFormData: this.checkFormData,
                checkParent: this.checkParent
            })
        ]);

        const form = h('form', {
            ref: 'searchForm',
            attrs: {
                id: this.id,
                action: this.action
            }
        }, [template]);

        return form;
    },
    data() {
        return {
            isInitialized: false,
            currentQuery: {
                type: String
            },
            sortBy: {
                type: String
            },
            numResults: {
                type: String
            },
            formData: {},
            flaggedData: [],
            id: 'component_uid_' + this._uid
        };
    },
    props: {
        action: {
            type: String,
            default: ''
        },
        queryString: {
            type: String,
            default: null
        },
        queryDelimeter: {
            type: String,
            default: '?'
        },
        sortByName: {
            type: String,
            default: 'sort-by'
        },
        numResultsName: {
            type: String,
            default: 'num-results'
        }
    },
    computed: {
        isValid() {
            return this.checkFormData;
        }
    },
    watch: {
        sortBy: function (val) {
            this.submitSearch();
        },
        numResults: function (val) {
            this.submitSearch();
        }
    },
    methods: {
        submitSearch() {
            // Don't submit search until default values are set
            if(this.isInitialized) {
                this.$nextTick(() => {
                    this.$refs.searchForm.submit();
                });
            }
        },
        manualSubmitSearch() {
            if(this.isInitialized) {
                this.$nextTick(() => {
                    const validQuery = this.checkFormData();
                    let url = this.action;
                    if(validQuery) {
                        let i = 0;
                        url += this.queryDelimeter;
                        for (const prop in this.formData) {
                            if(this.formData[prop] !== '') {
                                let flagged = false;
                                let z = 0;
                                do {
                                    if(this.flaggedData[z] === prop) {
                                        flagged = true;
                                    }
                                    z++;
                                } while (z < this.flaggedData.length && !flagged);
                                if(i > 0) {
                                    url += '&';
                                }
                                if(flagged) {
                                    url += prop + '=' + this.formData[prop];
                                } else {
                                    url += prop + '=[' + this.formData[prop] + ']';
                                }
                                i++;
                            }
                        }
                    }
                    window.location.href = url;
                });
            }
        },
        checkFormData() {
            for (const prop in this.formData) {
                if(this.formData[prop] !== '') {
                    return true;
                }
            }
            return false;
        },
        checkParent(el) {
            const root = '#' + this.id;
            const parent = closest(el, root);
            if(this.$el === parent) {
                return true;
            } else {
                return false;
            }
        }
    },
    mounted() {
        const params = queryParams();

        // Save the current query
        if(this.queryString && typeof params[this.queryString] !== 'undefined') {
            this.currentQuery = params[this.queryString];
        }

        this.$nextTick(() => {
            if(typeof params[this.sortByName] !== 'undefined') {
                this.sortBy = params[this.sortByName];
            }

            if(typeof params[this.numResultsName] !== 'undefined') {
                this.numResults = params[this.numResultsName];
            }

            this.$nextTick(() => {
                this.isInitialized = true;
            });
        });
    },
    created() {
        inputEventBus.$on('inputInit', (value, id, el) => {
            this.$nextTick(() => {
                const isParent = this.checkParent(el);
                if(isParent && !this.formData[id]) {
                    this.formData[id] = value;
                }
            });
        });

        inputEventBus.$on('inputInitFlagged', (value, id, el) => {
            this.$nextTick(() => {
                const isParent = this.checkParent(el);
                if(isParent) {
                    this.formData[id] = value;
                    this.flaggedData.push(id);
                }
            });
        });

        inputEventBus.$on('inputUpdated', (value, id, el) => {
            if(this.formData[id] !== value) {
                const isParent = this.checkParent(el);
                if(isParent) {
                    this.formData[id] = value;
                    this.$forceUpdate();
                }
            }
        });
    }
};



// WEBPACK FOOTER //
// ./src/app/components/aha-search-results-form.js